var _g, _g2, _path, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 781,
    viewBox: "0 0 511 781",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_71_2508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.578 544.783C470.578 822.109 238.057 1049.1 -51.4982 1049.1C-341.053 1049.1 -573.574 822.109 -573.574 544.783C-573.574 267.457 -341.053 40.4653 -51.4982 40.4653C238.057 40.4653 470.578 267.457 470.578 544.783Z",
    stroke: "url(#paint0_radial_71_2508)",
    strokeOpacity: 0.7,
    strokeWidth: 80
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_71_2508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.623 542.579C373.623 768.526 184.205 953.322 -51.4988 953.322C-287.203 953.322 -476.621 768.526 -476.621 542.579C-476.621 316.633 -287.203 131.836 -51.4988 131.836C184.205 131.836 373.623 316.633 373.623 542.579Z",
    stroke: "url(#paint1_radial_71_2508)",
    strokeOpacity: 0.65,
    strokeWidth: 60
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.6 542.577C272.6 714.017 128.716 855.171 -51.4979 855.171C-231.712 855.171 -375.596 714.017 -375.596 542.577C-375.596 371.137 -231.712 229.983 -51.4979 229.983C128.716 229.983 272.6 371.137 272.6 542.577Z",
    stroke: "url(#paint2_radial_71_2508)",
    strokeOpacity: 0.81,
    strokeWidth: 80
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.469,
    cy: 87.6976,
    rx: 26.9832,
    ry: 26.1307,
    fill: "url(#paint3_linear_71_2508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_71_2508",
    x: -623.574,
    y: -9.53467,
    width: 1144.15,
    height: 1108.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_71_2508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_71_2508",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_71_2508",
    x: -516.621,
    y: 91.8362,
    width: 930.244,
    height: 901.486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_71_2508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_71_2508",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_71_2508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-67.3067 568.597) rotate(88.7502) scale(724.795 748.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.654764,
    stopColor: "#FFC58B",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_71_2508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-64.2992 561.862) rotate(88.7502) scale(586.879 606.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.654764,
    stopColor: "#FFDCB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_71_2508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-61.7382 558.003) rotate(88.7502) scale(469.503 484.806)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.654764,
    stopColor: "#E2F6FC",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B7D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_2508",
    x1: 276.452,
    y1: 113.828,
    x2: 224.217,
    y2: 59.8897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF894E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750282,
    stopColor: "#834408"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/decoration.0a3084218761ac66bcd6503cb73454dc.svg";
export { ForwardRef as ReactComponent };